import React, { Component, useEffect } from 'react';
import './Education.css';
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import EducationList from "../Education/EducationList/EducationList";
import DarkModeToggle from '../Dark/DarkModeToggle';
import '../Dark/styles.scss';
let skill= [
   {
     "name":"Node",
     "level":"70%"
   },
   
   {
     "name":"ReactJs",
     "level":"80%"
   },
   {
     "name":"CSS",
     "level":"90%"
   },
   {
     "name":"KOTLIN",
     "level":"80%"
   },
   
   {
     "name":"Java",
     "level":"80%"
   }
 ];


const Education = () => {
  
   var skills = skill.map(function(skills){
      var className = 'bar-expand '+skills.name.toLowerCase();
      return <li key={skills.name}><span style={{height:skills.level}}className={className}></span><em>{skills.name}</em></li>})
   
      const animation = useAnimation();    
      const [ref, inView, entry] = useInView({ threshold: 0.1 });
      const variantsL = {
        visible: { opacity: 1, marginLeft: 0 },
        hidden: { opacity: 0, marginLeft: -500},
      }
      const variantsR = {
        visible: { opacity: 1, marginRight: 0 },
        hidden: { opacity: 0, marginRight: -500},
      }
      useEffect(() => {
        if (inView) {
          animation.start("visible");
        } else {
          animation.start("hidden");
        }
      }, [animation, inView]);
  
      
      return (
           <section id="about">
           
          <div
          className="Education">
                  <motion.div 
                      ref={ref}
                      animate={animation}
                      initial="hidden"
          
                      variants={variantsL}
                      className="LeftSection">
                      <div className="row skill">


<h1 className="Title"><span>SKILLS</span></h1>





<div className="bars">
<ul className="skills">
{skills}
</ul>
</div>

</div>
              </motion.div>
          
              <motion.div 
                      ref={ref}
                      animate={animation}
                      initial="hidden"
          
                      variants={variantsR}
                      className="RightSection">
                      <h1 className="Title1"><span>EDUCATION</span></h1>
                            <EducationList/>
              </motion.div>
          </div>
              
  
     </section>
        
      );
      }

export default Education;